(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-lds-contact]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const reason = root.querySelector('[data-lds-reason]');
      if (!reason) return;
      const help = root.querySelector('[data-lds-help]');
      const message = root.querySelector('[data-lds-message]');
      const groups = [...root.querySelectorAll('[data-lds-fields]')];
      function update() {
        const selected = reason.selectedOptions[0];
        const kind = selected?.dataset.kind || '';
        groups.forEach(group => {
          const active = group.dataset.ldsFields.split(' ').includes(kind);
          group.hidden = !active;
          group.querySelectorAll('input').forEach(input => {
            input.disabled = !active;
            input.required = active && input.hasAttribute('data-lds-required');
          });
        });
        help.textContent = selected?.dataset.help || help.dataset.default;
        message.placeholder = selected?.dataset.message || message.dataset.default;
      }
      function preselect() {
        const kind = new URLSearchParams(location.search).get('inquiry') || location.hash.slice(1);
        const option = [...reason.options].find(o => o.dataset.kind === kind);
        if (option) reason.value = option.value;
        update();
      }
      reason.addEventListener('change', update);
      window.addEventListener('hashchange', preselect);
      root.querySelector('form')?.addEventListener('reset', () => queueMicrotask(update));
      preselect();
      // Native Shopify POST, error handling and spam protection are deliberately
      // retained. Never intercept submission or display a synthetic success.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
